export default class CreateCustomerAccountRequest {
	name: string = '';
    productId: string = '';
    productIssueId: string = '';
    reviewDateUtc: Date = new Date();
    customerId: string = '';
    iban: string = '';
}